/* ESPEJOL · CONVETI Lab — simulación óptica de un espejo curvo (cóncavo ↔ convexo) */
(function () {
  'use strict';
  var VS = 'attribute vec2 a;varying vec2 v;void main(){v=a*.5+.5;gl_Position=vec4(a,0.,1.);}';
  var FS = [
    'precision highp float;',
    'uniform sampler2D T;uniform vec2 R;uniform float K;uniform vec2 L;uniform vec3 C;uniform float TC,TE,BR,CO,A,TM;',
    'varying vec2 v;',
    'vec3 S(vec2 q){vec2 t=vec2(.5+q.x*.5,.5-q.y*.5*A);t=clamp(t,.002,.998);return texture2D(T,t).rgb;}',
    'float h(vec2 p){return fract(sin(dot(p,vec2(12.9898,78.233)))*43758.5453);}',
    'void main(){',
    ' vec2 p=v*2.-1.;float r=length(p);float aa=3./R.x;',
    ' float m=1.-smoothstep(1.-aa,1.,r);if(m<=0.){gl_FragColor=vec4(0.);return;}',
    ' float k=K;float u=max(-k,0.);float x=max(k,0.);float s0=.56;vec2 q;float bl=0.;',
    ' if(k>=0.){float s=mix(s0,.42,x);q=p*(s+x*.36*r*r);}',
    ' else{float c=cos(u*3.14159265);float g=s0*c;q=p*g*(1.+.55*u*r*r);bl=(1.-abs(c))*.035+u*.004;}',
    ' q+=L*(.05-x*.025)*(k<0.?-1.:1.);',
    ' vec3 col=S(q);',
    ' if(bl>.0005){col*=.2;for(int i=0;i<8;i++){float a=float(i)*.785398+TM*.0;col+=S(q+vec2(cos(a),sin(a))*bl)*.1;}}',
    ' float tr=pow(r,1.6);float ta=mix(TC,TE,tr);col=mix(col,col*C,ta);',
    ' col=(col-.5)*CO+.5;col*=BR;',
    ' vec2 Ld=normalize(vec2(-.55,.72)+L*.35);',
    ' float sp=exp(-pow(length(p-Ld*.52),2.)*16.)*.30*x;col+=sp;',
    ' col*=1.-.38*x*smoothstep(.55,1.,r)*smoothstep(.55,1.,r);',
    ' float rim=smoothstep(.70,.975,r);float sd=.5+.5*dot(p/(r+1e-4),Ld);',
    ' col=mix(col,col*.5+vec3(1.,.97,.93)*.75*sd*sd,rim*u*.95);',
    ' col*=1.-.18*u*smoothstep(.6,.82,r)*(1.-smoothstep(.82,.9,r));',
    ' float ln=smoothstep(.962,.982,r)*(1.-smoothstep(.988,1.,r));col+=ln*(.10+.25*sd);',
    ' col+=(h(v*R+TM)-.5)*.018;',
    ' gl_FragColor=vec4(clamp(col,0.,1.)*m,m);',
    '}'
  ].join('\n');

  function hex(h) {
    h = (h || '#ffffff').replace('#', '');
    if (h.length === 3) h = h.replace(/./g, function (c) { return c + c; });
    var n = parseInt(h, 16);
    return [(n >> 16 & 255) / 255, (n >> 8 & 255) / 255, (n & 255) / 255];
  }

  function Lab(root) {
    this.root = root;
    this.canvas = root.querySelector('[data-ecl-canvas]');
    this.stage = root.querySelector('[data-ecl-stage]');
    this.range = root.querySelector('[data-ecl-range]');
    this.tints = Array.prototype.slice.call(root.querySelectorAll('.ecl__tint'));
    this.swaps = Array.prototype.slice.call(root.querySelectorAll('[data-ecl-swap]'));
    this.formLabel = root.querySelector('[data-ecl-form-label]');
    this.lineEl = root.querySelector('[data-ecl-line]');
    this.capEl = root.querySelector('[data-ecl-caption]');
    this.sizeEl = root.querySelector('[data-ecl-sizes]');
    this.cta = root.querySelector('[data-ecl-cta]');
    this.reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.kStart = parseFloat(root.getAttribute('data-k')) || 0.75;
    this.kT = this.reduced ? this.kStart : 0; this.k = this.kT; this.intro = this.reduced; root._ecl = this;
    this.tilt = [0, 0]; this.tiltT = [0, 0]; this.mouse = [0, 0];
    this.visible = false; this.form = null; this.t0 = performance.now();
    var sel = this.tints.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || this.tints[0];
    this.cur = this.read(sel); this.tgt = this.read(sel); this.sel = sel;
    if (!this.gl()) { root.classList.add('is-fallback'); }
    this.bind();
    this.updateTexts(true);
    this.updateTint(sel, true);
  }

  Lab.prototype.read = function (b) {
    if (!b) return { c: [1, 1, 1], tc: .2, te: .4, br: 1, co: 1 };
    return { c: hex(b.getAttribute('data-tint')), tc: +b.getAttribute('data-tc') || 0, te: +b.getAttribute('data-te') || 0, br: +b.getAttribute('data-br') || 1, co: +b.getAttribute('data-co') || 1 };
  };

  Lab.prototype.gl = function () {
    var c = this.canvas, gl;
    try { gl = c.getContext('webgl', { premultipliedAlpha: true, alpha: true, antialias: true }) || c.getContext('experimental-webgl'); } catch (e) { gl = null; }
    if (!gl) return false;
    function sh(t, s) { var o = gl.createShader(t); gl.shaderSource(o, s); gl.compileShader(o); if (!gl.getShaderParameter(o, gl.COMPILE_STATUS)) { throw new Error(gl.getShaderInfoLog(o)); } return o; }
    try {
      var pr = gl.createProgram();
      gl.attachShader(pr, sh(gl.VERTEX_SHADER, VS)); gl.attachShader(pr, sh(gl.FRAGMENT_SHADER, FS)); gl.linkProgram(pr);
      if (!gl.getProgramParameter(pr, gl.LINK_STATUS)) throw new Error('link');
      gl.useProgram(pr);
      var b = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, b);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
      var loc = gl.getAttribLocation(pr, 'a'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
      var u = {}; ['T', 'R', 'K', 'L', 'C', 'TC', 'TE', 'BR', 'CO', 'A', 'TM'].forEach(function (n) { u[n] = gl.getUniformLocation(pr, n); });
      this.g = gl; this.u = u; this.ready = false;
      var tex = gl.createTexture(); gl.bindTexture(gl.TEXTURE_2D, tex);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, new Uint8Array([200, 170, 140, 255]));
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      var self = this, img = new Image(); img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          gl.bindTexture(gl.TEXTURE_2D, tex);
          gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, img);
          self.asp = img.naturalWidth / img.naturalHeight; self.ready = true; self.root.classList.add('is-ready'); self.kick();
        } catch (e) { self.root.classList.add('is-fallback'); }
      };
      img.onerror = function () { self.root.classList.add('is-fallback'); };
      img.src = this.root.getAttribute('data-tex');
      c.addEventListener('webglcontextlost', function (e) { e.preventDefault(); self.root.classList.add('is-fallback'); });
      return true;
    } catch (e) { return false; }
  };

  Lab.prototype.resize = function () {
    if (!this.g) return;
    var d = Math.min(window.devicePixelRatio || 1, 2), w = Math.round(this.stage.clientWidth * d);
    if (this.canvas.width !== w) { this.canvas.width = w; this.canvas.height = w; this.g.viewport(0, 0, w, w); }
  };

  Lab.prototype.bind = function () {
    var self = this;
    this.range.addEventListener('input', function () { self.touch(); self.kT = self.range.value / 100; self.kick(); });
    this.tints.forEach(function (b) { b.addEventListener('click', function () { self.touch(); self.updateTint(b); self.kick(); }); });
    var drag = null;
    this.stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      drag = { x: e.clientX, y: e.clientY, k: self.kT, id: e.pointerId, on: false };
    });
    window.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'mouse') {
        var r = self.stage.getBoundingClientRect();
        self.mouse = [Math.max(-1, Math.min(1, (e.clientX - (r.left + r.width / 2)) / (r.width))), Math.max(-1, Math.min(1, (e.clientY - (r.top + r.height / 2)) / (r.height)))];
      }
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
      if (!drag.on) { if (Math.abs(dx) > 6 && Math.abs(dx) > Math.abs(dy)) { drag.on = true; self.touch(); } else if (Math.abs(dy) > 10) { drag = null; return; } else return; }
      var w = self.stage.clientWidth || 400;
      self.kT = Math.max(-1, Math.min(1, drag.k + dx / (w * .75)));
      self.range.value = Math.round(self.kT * 100); self.kick();
    }, { passive: true });
    window.addEventListener('pointerup', function () { drag = null; });
    window.addEventListener('pointercancel', function () { drag = null; });
    this.stage.addEventListener('mouseleave', function () { self.mouse = [0, 0]; });
    window.addEventListener('resize', function () { self.resize(); self.kick(); });
    var chk = function () {
      var r = self.stage.getBoundingClientRect(), h = window.innerHeight || document.documentElement.clientHeight || 800;
      var v = r.bottom > 0 && r.top < h && r.width > 0;
      if (v !== self.visible) { self.visible = v; if (v) { self.resize(); self.kick(); } }
    };
    window.addEventListener('scroll', chk, { passive: true });
    window.addEventListener('resize', chk);
    if ('IntersectionObserver' in window) { new IntersectionObserver(chk, { threshold: [0, 0.25] }).observe(this.stage); }
    chk();
  };

  Lab.prototype.touch = function () { if (!this.touched) { this.touched = true; this.root.classList.add('is-touched'); } };

  Lab.prototype.formOf = function (k) { return k < -0.12 ? 'concave' : (k > 0.12 ? 'convex' : 'flat'); };

  Lab.prototype.updateTexts = function (now) {
    var f = this.formOf(this.kT);
    if (f === this.form && !now) return;
    this.form = f;
    var self = this;
    this.swaps.forEach(function (el) {
      var t = el.getAttribute('data-' + f); if (t == null) return;
      if (now || self.reduced) { el.textContent = t; return; }
      el.classList.add('is-out');
      clearTimeout(el._t); el._t = setTimeout(function () { el.textContent = t; el.classList.remove('is-out'); }, 260);
    });
    if (this.formLabel) this.formLabel.textContent = this.root.getAttribute('data-lbl-' + f);
    this.range.setAttribute('aria-valuetext', this.root.getAttribute('data-lbl-' + f));
    this.updateSpec();
  };

  Lab.prototype.updateTint = function (b, now) {
    this.tints.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
    this.sel = b; this.tgt = this.read(b);
    if (now || this.reduced) this.cur = this.read(b);
    if (this.lineEl) this.lineEl.textContent = b.getAttribute('data-line') || '';
    this.updateSpec();
  };

  Lab.prototype.updateSpec = function () {
    var b = this.sel; if (!b) return;
    var f = this.form || this.formOf(this.kT), R = this.root;
    var name = b.getAttribute('data-name') || '';
    var data = f === 'flat' ? '' : (b.getAttribute(f === 'concave' ? 'data-cc' : 'data-cx') || '');
    var parts = data.split('|');
    var formName = R.getAttribute('data-lbl-' + f);
    this.capEl.textContent = f === 'flat' ? formName + ' · ' + name : 'CONVETI ' + formName + ' ' + name;
    if (parts[0]) {
      this.sizeEl.textContent = (parts[2] ? parts[2] + (/cm/i.test(parts[2]) ? '' : ' cm') + ' · ' : '') + R.getAttribute('data-lbl-from') + ' ' + parts[1];
      this.cta.href = parts[0]; this.cta.textContent = R.getAttribute('data-lbl-view') + ' ' + formName + ' ' + name;
    } else {
      this.sizeEl.textContent = '';
      this.cta.href = R.getAttribute('data-coll'); this.cta.textContent = R.getAttribute('data-lbl-coll');
    }
  };

  Lab.prototype.kick = function () {
    if (this.raf || !this.visible) return;
    var self = this; this.raf = requestAnimationFrame(function () { self.raf = 0; self.frame(); });
  };

  Lab.prototype.frame = function () {
    var t = (performance.now() - this.t0) / 1000, e = this.reduced ? 1 : 0.06, moving = false;
    if (!this.intro) { if (!this.introAt) this.introAt = t + 0.6; if (t >= this.introAt) { this.intro = true; if (!this.touched) this.kT = this.kStart; } moving = true; }
    var dk = this.kT - this.k; if (Math.abs(dk) > 0.0005) { this.k += dk * e; moving = true; } else this.k = this.kT;
    var c = this.cur, g = this.tgt;
    ['tc', 'te', 'br', 'co'].forEach(function (n) { var d = g[n] - c[n]; if (Math.abs(d) > 0.001) { c[n] += d * e; moving = true; } else c[n] = g[n]; });
    for (var i = 0; i < 3; i++) { var d = g.c[i] - c.c[i]; if (Math.abs(d) > 0.001) { c.c[i] += d * e; moving = true; } else c.c[i] = g.c[i]; }
    if (!this.reduced) {
      this.tiltT = [Math.sin(t * 2 * Math.PI / 14) * 0.5 + this.mouse[0] * 0.8, Math.sin(t * 2 * Math.PI / 19) * 0.35 - this.mouse[1] * 0.6];
      this.tilt[0] += (this.tiltT[0] - this.tilt[0]) * 0.05; this.tilt[1] += (this.tiltT[1] - this.tilt[1]) * 0.05; moving = true;
    }
    this.updateTexts(false);
    this.draw(t);
    if (moving) this.kick();
  };

  Lab.prototype.draw = function (t) {
    var gl = this.g; if (!gl || !this.ready) return;
    var u = this.u, c = this.cur;
    gl.clearColor(0, 0, 0, 0); gl.clear(gl.COLOR_BUFFER_BIT);
    gl.uniform1i(u.T, 0); gl.uniform2f(u.R, this.canvas.width, this.canvas.height);
    gl.uniform1f(u.K, this.k); gl.uniform2f(u.L, this.tilt[0], this.tilt[1]);
    gl.uniform3f(u.C, c.c[0], c.c[1], c.c[2]); gl.uniform1f(u.TC, c.tc); gl.uniform1f(u.TE, c.te);
    gl.uniform1f(u.BR, c.br); gl.uniform1f(u.CO, c.co); gl.uniform1f(u.A, this.asp || 1.24); gl.uniform1f(u.TM, this.reduced ? 0 : Math.floor(t * 12));
    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
  };

  function init() { Array.prototype.forEach.call(document.querySelectorAll('[data-ecl]:not([data-ecl-on])'), function (r) { r.setAttribute('data-ecl-on', ''); new Lab(r); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
